import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { IconField } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { InputIcon } from 'primeng/inputicon';
import { DividerModule } from 'primeng/divider';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, IconField, InputTextModule, FormsModule, InputIcon, DividerModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Output() widthChange = new EventEmitter<number>();
  isExpanded$ = new BehaviorSubject<boolean>(false);
  isPinned$ = new BehaviorSubject<boolean>(false);
  modules: any = [];
  permissions: any = [];
  sidebarItems: any[] = [];
  navBarItems: any[] = [];
  searchValue: string = '';

  constructor(private router: Router,
    private localStorage: LocalStorageService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.keepSubMenuOpen();
    });
  }



  ngOnInit() {
    this.updateWidth();
    this.keepSubMenuOpen();
    // this.modules = JSON.parse(this.localStorage.getFeatureModules());
    // console.log("modules", this.modules)
    // this.permissions = JSON.parse(this.localStorage.getPermissions());

    this.navBarItems = [
      {
        title: "Manage Clients",
        icon: "pi pi-users",
        route: "/main/clients",
        subMenu: null,
        show: true
      },
      {
        title: "Packages",
        icon: "pi pi-box",
        route: "/main/packages",
        subMenu: null,
        show: true
      },
      {
        title: "Features",
        icon: "pi pi-star",
        route: "/main/features",
        subMenu: null,
        show: true
      },
    ];

    this.sidebarItems = this.navBarItems;

    // make sidebar item open true if it is active
    this.sidebarItems.forEach(item => {
      if (item.subMenu) {
        item.isOpen = item.subMenu.some((sub: any) => this.router.url.includes(sub.route));
      }
    })
  }

  togglePin() {
    this.isPinned$.next(!this.isPinned$.value);
    if (this.isPinned$.value) {
      this.isExpanded$.next(true);
    }
    this.updateWidth();
  }

  expandSidebar() {
    if (!this.isPinned$.value) {
      this.isExpanded$.next(true);
    }
    // this.updateWidth();
  }

  collapseSidebar() {
    if (!this.isPinned$.value) {
      this.isExpanded$.next(false);
    }
    // this.updateWidth();
  }

  toggleSubMenu(item: any) {
    if (item.subMenu) {
      item.isOpen = !item.isOpen;
    }
  }

  keepSubMenuOpen() {
    this.sidebarItems.forEach(item => {
      if (item.subMenu) {
        item.isOpen = item.subMenu.some((sub: any) => this.router.url.includes(sub.route));
      }
    });
  }

  private updateWidth() {
    // const width = this.isExpanded$.value || this.isPinned$.value ? 210 : 54;
    const width = this.isPinned$.value ? 210 : 54;
    this.widthChange.emit(width);
  }

  getFeatureModuleAccess(module_name: any) {
    console.log(this.modules)
    console.log(this.modules.includes(module_name))
    return (this.modules.includes(module_name) ? true : false);
  }

  getAccess(module_name: any) {
    console.log("pemision",this.permissions)
    let result = this.permissions.filter((item: any) => {
      return item.module_name == module_name && item.active == true;
    })
    console.log("gaurav", result[0])
    return (result[0]) ? true : false;
    //return true;
  }

  search() {
    console.log(this.searchValue)

    if (this.searchValue == '') {
      this.sidebarItems =  this.navBarItems;
      return;
    }

    let newSidebarItems = this.sidebarItems.filter((item: any) => {
      if (item.title.toLowerCase().includes(this.searchValue.toLowerCase()) || (item.subMenu && item.subMenu.some((sub: any) => sub.title.toLowerCase().includes(this.searchValue.toLowerCase())))) {
        return item;
      }
    })

    console.log(newSidebarItems)

    this.sidebarItems = newSidebarItems;

  }

  getfeatureAccess(module_name: any, feature_name: any) {
    //console.log(this.permissions)
    let feature = [];
    let module = [];
    module = this.permissions.filter((item: any) => {
      return item.module_name == module_name;
    })
    if (module.length > 0) {
      feature = module[0]['features'].filter((item: any) => {
        return item.name == feature_name && item.active == true;
      })
    }

    return (module[0] && feature[0]) ? true : false;

  }
}
